import React, { useState } from "react";
import { resetPassword } from "../services/authService";
import "../styles/Login.css";

export default function Login({ onLoginSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSignup, setIsSignup] = useState(false);
  const [isReset, setIsReset] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      if (isReset) {
        // Handle password reset
        if (!email || !newPassword || !confirmPassword) {
          setError("Please fill in all fields");
          setLoading(false);
          return;
        }

        if (newPassword !== confirmPassword) {
          setError("Passwords do not match");
          setLoading(false);
          return;
        }

        if (newPassword.length < 6) {
          setError("Password must be at least 6 characters");
          setLoading(false);
          return;
        }

        const data = await resetPassword(email, newPassword);
        localStorage.setItem("authToken", data.token);
        localStorage.setItem("user", JSON.stringify(data.user));
        onLoginSuccess(data.user);
      } else {
        // Handle login/signup
        if (!email || !password) {
          setError("Please fill in all fields");
          setLoading(false);
          return;
        }

        const baseURL = (process.env.REACT_APP_API_URL || "http://localhost:3001").replace(/\/$/, "");
        const endpoint = isSignup ? "/api/auth/signup" : "/api/auth/login";
        const response = await fetch(baseURL + endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, password }),
        });

        const text = await response.text();
        const data = JSON.parse(text);

        if (!response.ok) {
          setError(data.message || "Authentication failed");
          setLoading(false);
          return;
        }

        // Save auth token
        localStorage.setItem("authToken", data.token);
        localStorage.setItem("user", JSON.stringify(data.user));

        onLoginSuccess(data.user);
      }
    } catch (err) {
      setError(err.message || "An error occurred");
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Nexeya Calendar</h1>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              disabled={loading}
            />
          </div>

          {!isReset ? (
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                disabled={loading}
              />
            </div>
          ) : (
            <>
              <div className="form-group">
                <label htmlFor="newPassword">New Password</label>
                <input
                  type="password"
                  id="newPassword"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Enter new password"
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label htmlFor="confirmPassword">Confirm Password</label>
                <input
                  type="password"
                  id="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirm new password"
                  disabled={loading}
                />
              </div>
            </>
          )}

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="btn-login" disabled={loading}>
            {loading ? "Loading..." : isReset ? "Reset Password" : isSignup ? "Sign Up" : "Login"}
          </button>
        </form>

        <p className="toggle-auth">
          {isReset ? (
            <>
              <button
                type="button"
                onClick={() => {
                  setIsReset(false);
                  setError("");
                  setNewPassword("");
                  setConfirmPassword("");
                }}
                className="link-btn"
                disabled={loading}
              >
                Back to Login
              </button>
            </>
          ) : (
            <>
              {isSignup ? "Have an account? " : "Don't have an account? "}
              <button
                type="button"
                onClick={() => {
                  setIsSignup(!isSignup);
                  setError("");
                }}
                className="link-btn"
                disabled={loading}
              >
                {isSignup ? "Login" : "Sign Up"}
              </button>
              {!isSignup && (
                <>
                  <br />
                  <button
                    type="button"
                    onClick={() => {
                      setIsReset(true);
                      setError("");
                      setPassword("");
                    }}
                    className="link-btn"
                    disabled={loading}
                  >
                    Forgot Password?
                  </button>
                </>
              )}
            </>
          )}
        </p>
      </div>
    </div>
  );
}
